<template>
  <div v-loading="loading">
    <Form>
      <FormItem :label="l('JIHUAMINGCHENG')">{{item.name}}</FormItem>
      <Row>
        <Col span="6">
          <FormItem :label="l('NIANDU')">{{item.year}}{{l("NIAN")}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('YUEFEN')">{{item.month}}{{l("YUE")}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('SUOSHUZUZHI')">{{item.domainName}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('GUANLIWEIDU')">{{item.dimensionNames}}</FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="6">
          <FormItem :label="l('KECHENGMULU')">{{item.courseTypeName}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('PEIXUNNEIRONG')">{{item.name}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('PEIXUNDUIXIANG')">{{item.trainObject}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('PEIXUNXINGSHI')">{{item.trainFormName}}</FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="6">
          <FormItem :label="l('PEIXUNLEIXING')">{{item.trainTypeName}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('KAOHEFANGSHI')">{{item.testMethodName}}</FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="l('PEIXUNDIZHI')">{{item.trainAddress}}</FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="6">
          <FormItem :label="l('YUSUANHEJI')">{{item.expenseBudget}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('RENCIHEJI')">{{item.expectedPeoples}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('KESHIHEJI')">{{item.expectedClassHours}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('NIFUXUEFEN')">{{item.credit || l("ZANWU")}}</FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="6">
          <FormItem :label="l('PEIXUNJIBIE')">{{item.trainingLevel || l("ZANWU") }}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('PEIXUNZHUYAONEIRONG')">{{item.trainingContent}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('GUANLIANNIANDUJIHUA')">{{item.yearName || l("ZANWU")}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('SHISHIBUMEN')">{{item.orgName}}</FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <FormItem :label="l('JIANGSHI')">{{item.teacherNames }}</FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="24" v-if="item.changePlan=='Y'">
          <Alert type="warning" show-icon>
            {{l('BIANGENGYUANYING')}}
            <span slot="desc">{{item.changeReason}}</span>
          </Alert>
        </Col>
        <Divider style="font-size:12px;">{{l('BIANGENGJIHUALISHI')}}</Divider>
        <Row>
          <Col span="24">
            <el-table :data="item.changeList" class="m-t" border size="small" style="height: 100%;">
              <el-table-column :label="l('YUEFEN')" prop="month" width="80"></el-table-column>
              <el-table-column :label="l('KECHENGMULU')" prop="courseTypeName"></el-table-column>
              <el-table-column :label="l('PEIXUNNEIRONG')" prop="name"></el-table-column>
              <el-table-column :label="l('PEIXUNDUIXIANG')" prop="trainObject"></el-table-column>
              <el-table-column :label="l('YUSUANHEJI')" prop="expenseBudget" width="80"></el-table-column>
              <el-table-column :label="l('RENCIHEJI')" prop="expectedPeoples" width="80"></el-table-column>
              <el-table-column :label="l('KESHIHEJI')" prop="expectedClassHours" width="80"></el-table-column>
              <el-table-column :label="l('PEIXUNZHUYAONEIRONG')" prop="trainingContent"></el-table-column>
              <el-table-column :label="l('SHIJIANFANWEI')" width="300">
                <template slot-scope="scope">{{scope.row.startTime}} - {{scope.row.endTime}}</template>
              </el-table-column>
              <el-table-column width="300" :label="l('BIANGENGYUANYING')" prop="changeReason"></el-table-column>
            </el-table>
          </Col>
        </Row>
      </Row>
    </Form>
  </div>
</template>

<script>
export default {
  name: "monthPlan",
  props: ["id"],
  data() {
    return {
      loading: false,
      item: {}
    };
  },
  methods: {
    _fetch(id) {
      if (id) {
        this.loading = true;
        this.http
          .request("sys/trainMonthPlan/info", { id: id })
          .then(result => {
            this.item = result.item;
          })
          .finally(() => (this.loading = false));
      }
    }
  },
  created: function() {
    this._fetch(this.id);
  }
};
</script>

<style scoped>
.ivu-form-item {
  margin-bottom: 0px;
  vertical-align: top;
  zoom: 1;
}
.plan-table {
  width: 100%;
}
.plan-table th {
  text-align: left;
  padding: 3px;
  border: 1px solid #eeeeee;
}
.plan-table td {
  text-align: left;
  height: 25px;
  line-height: 25px;
  padding: 3px;
  border: 1px solid #eeeeee;
}
</style>



// WEBPACK FOOTER //
// monthPlan.vue?794afd47